/**
 * Sidebar navigation items for the RaptorJob module.
 * Provides navigation to the dispatch view for next-generation job management.
 * Feature-flag gated via raptor-jobs-tab.
 */
// @react-compiler-disable
import { Work, WorkOutline } from '@mui/icons-material';

import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { useFeatureFlag } from '@/common/presentation/hooks/useFeatureFlag';
import { raptorJobRoutesMap } from './RaptorJobRoutes';

export interface RaptorJobNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const RaptorJobNavItems = (): RaptorJobNavItemsResult => {
  const isRaptorJobEnabled = useFeatureFlag(FEATURE_FLAGS.RAPTOR_JOBS_TAB);

  const navItems: NavItemType = {
    id: 'raptorjob',
    title: 'Raptor Jobs',
    type: 'collapse',
    icon: WorkOutline,
    iconSelected: Work,
    url: raptorJobRoutesMap.list,
    featureFlag: FEATURE_FLAGS.RAPTOR_JOBS_TAB,
    disabled: !isRaptorJobEnabled,
    children: [
      {
        id: 'dispatch',
        title: 'Dispatch',
        type: 'item',
        url: raptorJobRoutesMap.list,
        featureFlag: FEATURE_FLAGS.RAPTOR_JOBS_TAB
      }
    ]
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default RaptorJobNavItems;
